export default "__VITE_PUBLIC_ASSET__368e8647__"